import { cn } from "app/lib/utils"
import {
  CIRCLE_BUTTON_SIZE_CLASS,
  type CircleButtonSize,
} from "app/player/controlSizes"
import { cva, type VariantProps } from "class-variance-authority"
import { ComponentProps, forwardRef } from "react"

const playerCircleButtonVariants = cva(
  "inline-flex shrink-0 items-center justify-center rounded-full border-[1px] border-black shadow-[0_0_4px_rgba(0,0,0,0.25)] outline-none transition-colors select-none focus-visible:ring-3 focus-visible:ring-ring/50",
  {
    variants: {
      color: {
        actie: "bg-actie-500 hover:bg-actie-700 active:bg-orange-700",
        neutraal:
          "bg-neutraal-900 hover:bg-[linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.1)),linear-gradient(#03004e,#03004e)] active:bg-[linear-gradient(rgba(255,255,255,0.2),rgba(255,255,255,0.2)),linear-gradient(#03004e,#03004e)]",
        white:
          "bg-white hover:bg-[linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.1)),linear-gradient(white,white)] active:bg-[linear-gradient(rgba(255,255,255,0.2),rgba(255,255,255,0.2)),linear-gradient(white,white)]",
      },
      size: CIRCLE_BUTTON_SIZE_CLASS,
    },
    defaultVariants: {
      color: "neutraal",
      size: "md",
    },
  }
)

type Props = Omit<ComponentProps<"button">, "size"> &
  VariantProps<typeof playerCircleButtonVariants> & {
    size?: CircleButtonSize
  }

const PlayerCircleButton = forwardRef<HTMLButtonElement, Props>(
  (
    { className, color = "neutraal", size = "md", type = "button", ...props },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(playerCircleButtonVariants({ color, size }), className)}
        {...props}
      />
    )
  }
)

PlayerCircleButton.displayName = "PlayerCircleButton"

export default PlayerCircleButton
